var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M15.4,27.3h69.2c4.8,0,7.2,5.8,3.8,9.2L53.8,71.1c-2.1,2.1-5.5,2.1-7.6,0L11.6,36.5C8.2,33.1,10.6,27.3,15.4,27.3z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }